import React from "react";

import "./priceExplanation.scss";
interface PriceExplanationInterface {
  tipoTarifa: string;
  explicaciones: any;
  tituloExplicacion: any;
}

const PriceExplanation = (props: PriceExplanationInterface) => {
  const { tipoTarifa, explicaciones, tituloExplicacion } = props;

  return (
    <div className="m-priceExplanation__details-container">
      <div className="m-priceExplanation__details-type">
        <p>{tipoTarifa}</p>
      </div>
      <div className="m-priceExplanation__details-explanation">
        {tituloExplicacion && (
          <p className="m-priceExplanation__details-explanationTitle">
            {tituloExplicacion}
          </p>
        )}
        <div>{explicaciones}</div>
      </div>
    </div>
  );
};

export default PriceExplanation;
